document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu]');
  const menu = document.querySelector('.mobile-nav');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menu?.toggleAttribute('open', open);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.hasAttribute('open')) {
      menu.removeAttribute('open');
      menuButton?.setAttribute('aria-expanded', 'false');
      menuButton?.focus();
    }
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      const buyButton = form?.querySelector('[type=submit]');
      if (buyButton) {
        buyButton.disabled = option.dataset.available !== 'true';
        buyButton.textContent = buyButton.disabled ? 'Sold out' : 'Add to cart';
      }
      const price = document.querySelector('[data-product-price]');
      if (price) price.textContent = option.dataset.price;
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  });

  const upsell = document.querySelector('[data-random-upsell]');
  if (upsell) {
    const title = upsell.querySelector('[data-upsell-title]');
    const description = upsell.querySelector('[data-upsell-description]');
    const price = upsell.querySelector('[data-upsell-price]');
    const imageSlot = upsell.querySelector('[data-upsell-image]');
    const addButton = upsell.querySelector('[data-add-random-upsell]');
    const excluded = new Set((upsell.dataset.cartProductIds || '').split(',').filter(Boolean));

    const loadRandomProduct = async () => {
      try {
        const response = await fetch(upsell.dataset.productsUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Products could not be loaded');
        const data = await response.json();
        const candidates = (data.products || []).flatMap((product) => {
          if (excluded.has(String(product.id)) || product.handle === 'name-customized-jewelry-box' || (product.tags || []).includes('upsell-only')) return [];
          if (!product.title || /not written yet/i.test(product.title)) return [];
          const variant = (product.variants || []).find((item) => item.available && Number.parseFloat(item.price) > 0);
          if (!variant) return [];
          const photo = product.image?.src || product.images?.[0]?.src;
          const description = new DOMParser().parseFromString(product.body_html || '', 'text/html').body.textContent?.replace(/\s+/g, ' ').trim() || '';
          if (!photo || !description || /not written yet/i.test(description)) return [];
          return [{ product, variant, photo, description }];
        });
        if (!candidates.length) throw new Error('No available products found');

        const choice = candidates[Math.floor(Math.random() * candidates.length)];
        title.textContent = choice.product.title;
        description.textContent = choice.description.slice(0, 150);
        const numericPrice = Number.parseFloat(choice.variant.price);
        price.textContent = `LE ${numericPrice.toLocaleString('en-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        if (choice.photo && imageSlot) {
          const photoUrl = new URL(choice.photo, location.origin);
          if (photoUrl.protocol === 'https:') {
            imageSlot.src = photoUrl.href;
            imageSlot.alt = choice.product.title;
            imageSlot.hidden = false;
          }
        }
        addButton.dataset.variantId = String(choice.variant.id);
        addButton.disabled = false;
      } catch (error) {
        upsell.hidden = true;
      }
    };

    addButton?.addEventListener('click', async () => {
      addButton.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(addButton.dataset.variantId), quantity: 1 }),
        });
        if (!response.ok) throw new Error('Product could not be added');
        location.reload();
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = 'Try again';
      }
    });

    loadRandomProduct();
  }

  const hero = document.querySelector('[data-hero-carousel]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;
    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
    };
    const stopRotation = () => window.clearInterval(timer);
    const startRotation = () => {
      stopRotation();
      if (!reducedMotion && !document.hidden && slides.length > 1) {
        timer = window.setInterval(() => showSlide(activeIndex + 1), 6500);
      }
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      showSlide(index);
      startRotation();
    }));
    hero.addEventListener('pointerenter', stopRotation);
    hero.addEventListener('pointerleave', startRotation);
    hero.addEventListener('focusin', stopRotation);
    hero.addEventListener('focusout', startRotation);
    document.addEventListener('visibilitychange', startRotation);
    startRotation();
  }
});


// Product image carousel: touch swipe, keyboard scrolling, arrows, and pagination.
document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const dots = [...gallery.querySelectorAll('[data-gallery-go]')];
  const counter = gallery.querySelector('[data-gallery-counter]');
  if (!track || slides.length < 2) return;
  let active = 0;
  const show = (index) => {
    active = (index + slides.length) % slides.length;
    track.scrollTo({ left: slides[active].offsetLeft - slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === active);
      if (dotIndex === active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
  };
  gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(active - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.galleryGo))));
  let settleTimer;
  track.addEventListener('scroll', () => {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(() => {
      const center = track.scrollLeft + track.clientWidth / 2;
      const nearest = slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
      if (nearest !== active) {
        active = nearest;
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === active);
          if (dotIndex === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      }
    }, 80);
  }, { passive: true });
});
